import { configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import storageSession from 'redux-persist/lib/storage/session';
import { combineReducers } from 'redux';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import appReducer from '../features/app/appSlice';
import registrationJourneyReducer from '../features/registration/registrationJourneySlice';
import applicationJourneyReducer from '../features/application/applicationJourneySlice';
import installerJourneyReducer from '../features/installer/installerJourneySlice';
import dashboardReducer from '../features/dashboard/dashboardSlice';
import pmcJourneyReducer from '../features/pmc/pmcJourneySlice';
import gaReducer from '../features/ga/gaSlice';
import customerReducer from '../features/customer/customerJourneySlice';

export const history = createBrowserHistory();

const reducers = combineReducers({
  app: appReducer,
  customer: customerReducer,
  registrationJourney: registrationJourneyReducer,
  applicationJourney: applicationJourneyReducer,
  installerJourney: installerJourneyReducer,
  pmcJourney: pmcJourneyReducer,
  dashboardSlice: dashboardReducer,
  gaSlice: gaReducer,
  router: connectRouter(history),
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage: storageSession,
  whitelist: [
    'customer',
    'installerJourney',
    'registrationJourney',
    'applicationJourney',
    'pmcJourney',
    'dashboardSlice',
    'connectRouter',
    'gaSlice',
  ],
  blacklist: ['app'],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'app/getCopyProviderCY',
          'app/getCpyProviderEN',
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
        ignoredPaths: [
          'app.copyProviderCY',
          'app.copyProviderEN',
          'installer.dateOfGrantApplication',
        ],
      },
    }).concat(routerMiddleware(history)),
});
